import useMutationApi from 'src/api/useMutationApi';
import type ApiResponse from 'src/api/ApiResponse';

interface SendEdi856TransactionParams {
  famousShipmentId: string;
  /** If true, allows resending even if already sent (for development/testing) */
  force?: boolean;
  /**
   * Send on the TEST stream and leave the shipment's 856 status untouched.
   * Admin only (the backend rejects non-admins).
   */
  test?: boolean;
}

/** What the send route returns. Only a test send needs to read it. */
export interface SendEdi856TransactionResult {
  transactionId?: string;
  test?: boolean;
}

const useSendEdi856Transaction = (
  onSuccess?: (
    data: ApiResponse<SendEdi856TransactionResult>,
    variables: SendEdi856TransactionParams,
  ) => void,
  onError?: () => void,
) => {
  return useMutationApi<
    SendEdi856TransactionParams,
    SendEdi856TransactionResult
  >({
    endpoint: 'famous/shipments/send-edi-856',
    method: 'POST',
    options: {
      onSuccess,
      onError,
    },
  });
};

export default useSendEdi856Transaction;
